import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { AuthService } from 'app/core/services/auth.service';
import { ExternalRedirectService } from 'app/core/services/external-redirect.service';
import { isOrgLessPlatformStaff } from 'app/shared/constants';
import { environment } from 'environments/environment';

/**
 * Kanban #574 (owner decision): platform staff with no org hat have no org, so every
 * org-scoped page in this shell can only 403. Send them to their admin area (nera-sa-portal),
 * the same place RoleRedirectGuard lands them from `/`.
 */
export const orgLessStaffGuard: CanActivateChildFn = (_route, state) => {
    if (
        state.url.startsWith('/forbidden') ||
        !isOrgLessPlatformStaff(inject(AuthService).user?.roles)
    ) {
        return true;
    }
    inject(ExternalRedirectService).assign(
        environment.saPortalUrl.replace(/\/$/, '')
    );
    return false;
};
